import React from "react";
import { Heart } from "lucide-react";
import { SITE } from "../lib/site";
import { useSite } from "../lib/SiteContext";

export default function Footer() {
  const { config } = useSite();
  const c = config.contact || {};
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1C1917] text-[#D6D3D1] pt-16 pb-10"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#D85C41] text-white">
                <Heart className="h-4 w-4" strokeWidth={2.5} />
              </span>
              <span className="font-display text-lg font-extrabold text-white">
                {SITE.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-[#A8A29E] max-w-md">
              A volunteer-run laundromat program providing free wash, dry, and
              fold services to displaced children and families in Hamilton.
              Restoring dignity, one load at a time.
            </p>
            <a
              href={c.donate_url || SITE.donateUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-donate-btn"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#D85C41] px-6 py-3 text-sm font-semibold text-white hover:bg-[#BD4C33] transition-all"
            >
              <Heart className="h-4 w-4" strokeWidth={2.5} />
              Donate via Venmo
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.16em] text-[#EBB04D]">
              Explore
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#mission" className="hover:text-white">Mission</a></li>
              <li><a href="#impact" className="hover:text-white">Impact</a></li>
              <li><a href="#how" className="hover:text-white">How it works</a></li>
              <li><a href="#stories" className="hover:text-white">Stories</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.16em] text-[#EBB04D]">
              Get in touch
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href={`mailto:${c.email || SITE.email}`} className="hover:text-white">{c.email || SITE.email}</a></li>
              <li>{c.address || SITE.address}</li>
              <li>{c.hours || SITE.hours}</li>
              <li><a href="#request" className="hover:text-white">Request free laundry help →</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-[#2E2825] pt-6 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-[#78716C]">
          <p>© {new Date().getFullYear()} {SITE.name}. Built with love for Hamilton.</p>
          <p>A community-run nonprofit. Donations are not tax receipts.</p>
        </div>
      </div>
    </footer>
  );
}
